module.exports = __webpack_public_path__ + "img/ian.a401014.png";